const STATUS_PREFIX = 'TELEMATICS.ACCOUNT.OVERVIEW.STATUSES';

export function hasDeviceCounts({ reportingDevicesCount, totalDevicesCount } = {}) {
  return Number.isInteger(reportingDevicesCount) && Number.isInteger(totalDevicesCount);
}

export function hasSilentDevices(record) {
  return hasDeviceCounts(record) && record.reportingDevicesCount !== record.totalDevicesCount;
}

export function totalDevices(record) {
  return hasDeviceCounts(record) ? record.totalDevicesCount : null;
}

export function resolveStatusTooltip(record = {}) {
  const { workingStatus, reportingDevicesCount } = record;
  const key = (suffix) => `${STATUS_PREFIX}.${workingStatus}.${suffix}`;

  if (!hasDeviceCounts(record)) {
    return { key: key('TOOLTIP'), params: {} };
  }

  const total = totalDevices(record);

  if (workingStatus === 'CONNECTED') {
    return reportingDevicesCount === total
      ? { key: key('TOOLTIP_ALL'), params: { total } }
      : { key: key('TOOLTIP_PARTIAL'), params: { reporting: reportingDevicesCount, total } };
  }

  if (workingStatus === 'ERROR') {
    if (total === 0) {
      return { key: key('TOOLTIP_NO_DEVICES'), params: {} };
    }
    return reportingDevicesCount === 0
      ? { key: key('TOOLTIP_NONE_REPORTING'), params: { total } }
      : { key: key('TOOLTIP'), params: {} };
  }

  return { key: key('TOOLTIP'), params: {} };
}
